const msalScopes = ['email', 'openid', 'profile', 'offline_access']

const authConfig = {
  authority: 'https://login.microsoftonline.com/e2f449a1-4cf6-43e3-911c-74f3ca9744f3',
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  },
  redirectUri: '/'
}

export { msalScopes, authConfig }
